'use client';

import type {ComponentProps, FC} from 'react';
import type {VariantProps} from 'class-variance-authority';
import {cva} from 'class-variance-authority';

import {cn} from '@/modules/foundation/shared/tailwind';

const label = cva(['mb-1 block font-semibold'], {
	variants: {
		size: {
			sm: 'text-sm lg:text-base',
			md: 'text-base lg:text-lg',
			lg: 'text-lg lg:text-xl',
		},
	},
	defaultVariants: {
		size: 'md',
	},
});

export type LabelProps = VariantProps<typeof label> & Omit<ComponentProps<'label'>, 'size'>;

export const Label: FC<LabelProps> = ({size, className, ...rest}) => {
	return <label className={cn(label({size, className}))} {...rest} />;
};
